import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss']
})
export class AiChatComponent implements OnInit {

  constructor(private router : Router) { }

  ngOnInit() {
     const isMobile = window.innerWidth <= 768;

    if (!isMobile) {
      this.router.navigate(['/']); // redirect to homepage
    }
  }
  goHome(){
  this.router.navigate(['/']);
}

}
